import Vue from 'vue'
export const preventReClick = Vue.directive('preventReClick', {
  // 指令的定义
  inserted: function (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 3000)
      }
    })
  }
})

export const int = Vue.directive('int', {
  bind: function (el) {
    // const input = el.getElementsByTagName('input')[0]
    const input = el
    input.onkeyup = function (e) {
      if (input.value.length === 1) {
        input.value = input.value.replace(/[^0-9]/g, '')
      } else {
        input.value = input.value.replace(/[^\d]/g, '')
      }
      trigger(input, 'input')
    }
    input.onblur = function (e) {
      if (input.value.length === 1) {
        input.value = input.value.replace(/[^0-9]/g, '')
      } else {
        input.value = input.value.replace(/[^\d]/g, '')
      }
      trigger(input, 'input')
    }
  }
})

const trigger = (el, type) => {
  const e = document.createEvent('HTMLEvents')
  e.initEvent(type, true, true)
  el.dispatchEvent(e)
}
// 拖拽指令
export const drag = Vue.directive('drag', {
  inserted: function (el) {
    console.log("拖拽")
    let oDiv = el; //获取当前元素
    let firstTime = "", lastTime = "";
    el.style.cursor = "grab"
    el.onmousedown = function (e) {
      var disX = e.pageX - el.offsetLeft;
      var disY = e.pageY - el.offsetTop;
      // 给当前元素添加属性，用于元素状态的判断
      oDiv.setAttribute("ele-flag", false)
      oDiv.setAttribute("dragging-flag", true)
      el.style.cursor = "grabbing"
      firstTime = new Date().getTime();
      document.onmousemove = function (e) {
        el.style.left = e.pageX - disX + "px";
        el.style.top = e.pageY - disY + "px";
      }
      document.onmouseup = function (event) {
        el.style.cursor = "grab"
        document.onmousemove = document.onmouseup = null;
        lastTime = new Date().getTime();
        if ((lastTime - firstTime) > 200) {
          oDiv.setAttribute("ele-flag", true)
          event.stopPropagation()
        }
        setTimeout(function () {
          oDiv.setAttribute("dragging-flag", false)
        }, 100)
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/utils/directive.js